import { supabase } from '../supabase/config';

/**
 * Logs an activity to the 'activities' table.
 *
 * @param {string} tenantId - The current tenant ID.
 * @param {string} userEmail - The email of the person performing the action.
 * @param {string} userId - The user ID performing the action.
 * @param {string} action - Action code (e.g., 'CREATE_DISCOUNT', 'UPDATE_CUSTOMER').
 * @param {string} details - Human-readable description of the action.
 * @param {object} metadata - Additional context or data related to the action.
 */
export const logActivity = async (tenantId, userEmail, userId, action, details, metadata = null) => {
    try {
        if (!tenantId || !userEmail || !action) {
            console.warn('activityLogger: Missing required parameters', { tenantId, userEmail, action });
            return;
        }

        const { error } = await supabase.from('activities').insert({
            tenant_id: tenantId,
            user_email: userEmail,
            user_id: userId || null,
            action,
            details,
            metadata,
            timestamp: new Date().toISOString()
        });

        if (error) throw error;
    } catch (err) {
        console.error('Error logging activity:', err);
    }
};
